export default "__VITE_ASSET__DsrbmyeH__"